import styled from "styled-components";
import Hamburger from "../../skeleton/Hamburger";
import { hamburgerStore } from "../../../state/ui/hamburger_state";
import UseBreakpoints from "../../hooks/ui/UseBreakpoints";
const HeaderPart = () => {
  const hamburgerState = hamburgerStore();
  const breakpoints = UseBreakpoints();
  if (breakpoints.xl) return null;
  const opened = hamburgerState.isOpened;
  return (
    <>
      <Opener
        type="button"
        aria-label={opened ? "메뉴 닫기" : "메뉴 열기"}
        aria-expanded={opened}
        $opened={opened}
        onClick={() => (opened ? hamburgerState.close() : hamburgerState.open())}
      >
        <span />
        <span />
        <span />
      </Opener>
      {opened && <Hamburger />}
    </>
  );
};

export default HeaderPart;
const Opener = styled.button`
  position: relative;
  width: 2.75rem;
  height: 2.75rem;
  margin-right: -0.5rem;
  border: 0;
  border-radius: 0.5rem;
  background: transparent;
  cursor: pointer;
  & > span {
    position: absolute;
    left: 0.7rem;
    right: 0.7rem;
    height: 2px;
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.dark};
    transition: transform 0.2s, opacity 0.2s;
    &:nth-child(1) {
      top: 0.9rem;
      transform: ${({ $opened }) => ($opened ? "translateY(0.45rem) rotate(45deg)" : "none")};
    }
    &:nth-child(2) {
      top: 1.35rem;
      opacity: ${({ $opened }) => ($opened ? 0 : 1)};
    }
    &:nth-child(3) {
      top: 1.8rem;
      transform: ${({ $opened }) => ($opened ? "translateY(-0.45rem) rotate(-45deg)" : "none")};
    }
  }
`;
